// Pages
import HomePage from '@js/pages/HomePage.vue'
import ResultPage from '@js/pages/ResultPage.vue'
import ErrorPage from '@js/pages/ErrorPage.vue'
import ContentPage from '@js/pages/ContentPage.vue'
import StatusPage from '@js/pages/StatusPage.vue'
import RatesTablePage from '@js/pages/RatesTablePage.vue'
import ApplyPage from '@js/pages/ApplyPage.vue'
import FraudDecline from '@js/pages/FraudDecline.vue'

import { url } from '@js/utilities/url.js'
import { JourneyCreator } from '@js/utilities/journey'

const currentRatesTableRoute = window.TEMPLATE === 'rates_table' ? window.PAGE_SLUG : 'rates-table'

const generalRoutes = function () {
    return [
        {
            path: url('/'),
            name: 'home',
            component: HomePage,
        },
        {
            path: url('/result/:reference'),
            alias: url('/declined/:reference'),
            name: 'result',
            component: ResultPage,
        },
        {
            path: url('/agent-result/:reference'),
            alias: url('/agent-declined/:reference'),
            name: 'agent_result',
            component: ResultPage,
            props: {
                isAgentPage: true,
            },
        },
        {
            path: url('/crm-result/:reference'),
            alias: url('/crm-declined/:reference'),
            name: 'crm_result',
            component: ResultPage,
            props: {
                isCrmPage: true,
            },
        },
        {
            path: url('/status'),
            name: 'status',
            component: StatusPage,
        },
        {
            path: url(`/${currentRatesTableRoute}`),
            name: 'rates_table',
            component: RatesTablePage,
        },
        {
            path: url('/:slug'),
            component: ContentPage,
        },
        {
            path: url('/no-success'),
            name: 'fraud_decline',
            component: FraudDecline,
        },
    ]
}

// the journey children will be added dynamically
const applyRoutes = function () {
    const applyPath = JourneyCreator.getApplyPath()

    return [
        {
            path: url(`/${applyPath}`),
            name: 'apply',
            component: ApplyPage,
        },
    ]
}

const errorRoutes = function (i18n) {
    const { t } = i18n.global

    return [
        {
            path: '/:pathMatch(.*)*',
            name: '404',
            meta: {
                title: t('errors.pages.notFound.heading'),
                description: t('errors.pages.notFound.description'),
            },
            component: ErrorPage,
        },
    ]
}

export { generalRoutes, applyRoutes, errorRoutes }
